import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import NavItem from './NavItem';
import logo from '../../../../assets/images/logo.png'

const SidebarNav = () => {
  const theme = useTheme();
  const { mode } = theme.palette;


  return (
    <Box>

      <Box
        display={'flex'}
        justifyContent={'center'} 
        width={1} 
        paddingX={2} 
        paddingY={1}
      >
        {/* --- Website Logo --- */}
        <Box
          component="a"
          display={'flex'}
          href="/"
          title="theFront"
          width={{ xs: 150, md: 200 }}
        >
          <Box
            component={'img'}
            src={
              mode === 'light'
                ? logo
                : logo
            }
            height={1}
            width={1}
          />
        </Box>
      </Box>
      <Box paddingX={2} paddingY={2}>
        <Box marginY={1}>
          <NavItem title={'Home'} linkTo={'/'}  />
        </Box>
        <Box marginY={1}>
          <NavItem title={'Tutorials'} linkTo={'/tutorials'} />
        </Box>
        <Box marginY={1}>
          <NavItem title={'About'} linkTo={'/about'} />
        </Box>
        
        
       
      </Box>
    </Box>
  );
};

export default SidebarNav;
